var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.956 511.956",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575f64",
    d: "m252.964 443.899-62.402-62.402-62.578 64.702 61.347 61.333c5.859 5.859 15.351 5.86 21.211 0l42.422-42.422c5.859-5.859 5.859-15.351 0-21.211z",
    opacity: 1,
    "data-original": "#575f64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7f0eb",
    d: "m367.141 231.094-65.054-65.054-89.165-89.165-35.779-5.779c-18.644 70.82-42.9 131.528-102.458 194.524l18.34 48.34 30.571 30.571 26.616 26.616 52.295 22.295c62.126-58.751 122.303-83.458 194.522-102.46z",
    opacity: 1,
    "data-original": "#f7f0eb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1d3ce",
    d: "M202.507 393.443c62.126-58.751 122.303-83.458 194.522-102.46l-29.888-59.888-65.054-65.054-178.491 178.491 26.616 26.616z",
    opacity: 1,
    "data-original": "#e1d3ce",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe06a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.956 91.029c-8.291 0-15-6.709-15-15v-61c0-8.291 6.709-15 15-15s15 6.709 15 15v61c0 8.292-6.709 15-15 15zM369.247 119.447c-7.412-3.706-10.415-12.715-6.709-20.127l30-60a15.024 15.024 0 0 1 11.016-8.101c4.805-.732 9.609.806 13.008 4.204l15.278 15.278 21.698-42.382c3.721-7.412 12.7-10.386 20.127-6.709 7.412 3.706 10.415 12.715 6.709 20.127l-31 61a15.024 15.024 0 0 1-11.016 8.101c-4.775.806-9.609-.791-13.008-4.204l-15.278-15.278-20.698 41.382c-3.691 7.362-12.647 10.424-20.127 6.709zM454.398 181.806l-19.482-23.525-18.354 18.354c-5.859 5.859-15.352 5.859-21.211 0s-5.859-15.352 0-21.211l30-30c2.974-2.988 7.134-4.512 11.309-4.38a15.04 15.04 0 0 1 10.854 5.42l18.442 22.266 19.442-23.266c5.303-6.372 14.751-7.266 21.123-1.992 6.387 5.288 7.266 14.751 1.992 21.123l-31 37.211c-6.006 7.239-17.103 7.244-23.115 0z",
    fill: "#ffe06a",
    opacity: 1,
    "data-original": "#ffe06a",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6c6c",
    d: "M446.191 255.286 329.517 138.612 212.842 21.937c-8.306-8.337-22.37-4.215-25.151 6.973-2.518 10.124-8.776 35.059-10.547 42.188l109.944 109.944L397.03 290.984l42.189-10.545c11.277-2.805 15.221-16.904 6.972-25.153z",
    opacity: 1,
    "data-original": "#ff6c6c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0004f",
    d: "M439.219 280.438c11.277-2.803 15.222-16.902 6.973-25.151L329.517 138.612l-42.429 42.429L397.03 290.983l42.189-10.545z",
    opacity: 1,
    "data-original": "#d0004f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6c6c",
    d: "M138.596 329.532c-20.781-20.779-41.558-41.559-63.911-63.911-2.602 2.752-5.063 5.605-7.742 8.284L21.928 318.92c-29.238 29.238-29.238 76.831 0 106.069l10.605 10.605 10.605 10.605c29.134 29.165 76.617 29.469 106.055 0 12.587-12.599 36.632-36.606 45.029-45.015 2.679-2.679 5.532-5.138 8.284-7.742-22.35-22.352-43.131-43.129-63.91-63.91z",
    opacity: 1,
    "data-original": "#ff6c6c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0004f",
    d: "M149.194 446.199c12.587-12.599 36.632-36.606 45.029-45.015 2.679-2.679 5.532-5.138 8.284-7.742-22.352-22.354-43.132-43.13-63.911-63.911L32.534 435.594l10.605 10.605c29.135 29.165 76.617 29.469 106.055 0z",
    opacity: 1,
    "data-original": "#d0004f",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetThree);
export default __webpack_public_path__ + "static/media/targetThree.a82a24d55cc7583f1e8ce043a9cb954e.svg";
export { ForwardRef as ReactComponent };